
Vue.config.productionTip = false;

import 'bootstrap';
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import VueRouter from 'vue-router'
import App from './App.vue'

// hier werden die Routen definiert:
import { routes } from './routes.js';  
 
// Router-Modul benutzen
Vue.use(VueRouter);
 
// neuen Router instantiieren:
const router = new VueRouter({ 
  "routes": routes 
});

// noch nichts:
const store = new  Vuex.Store({
});


new Vue({
  el: '#app',
  // den neuen Router benutzen:
  "router": router,
  "store": store,
  render: h => h(App),
}).$mount('#app');
